/*路由配置JS*/
import Vue from 'vue'
import Router from 'vue-router'
/*引入路由组件*/
/*import home from '@/components/home'
import page1 from '@/components/page1'
import page1Children from '@/components/page1Children'*/

/* import home from '@/components/home'
import service from '@/components/service'
import serviceList from '@/components/serviceList'
import serviceOne from '@/components/serviceOne'
import serviceTwo from '@/components/serviceTwo'
import serviceThree from '@/components/serviceThree'
import serviceFour from '@/components/serviceFour'
import cantact from '@/components/cantact'
import cantactMap from '@/components/cantactMap'
import cases from '@/components/cases'
import casesList from '@/components/casesList'
import casesDetail from '@/components/casesDetail'
import cantactRecruitment from '@/components/cantactRecruitment'
import about from '@/components/about' */


/*组件按需异步加载，webpackChunkName相同则打包成一个代码包*/
const home = () => import(/*webpackChunkName:"home"*/'@/components/home')
const service = () => import(/*webpackChunkName:"service"*/'@/components/service')
const serviceList = () => import(/*webpackChunkName:"service"*/'@/components/serviceList')
const serviceOne = () => import(/*webpackChunkName:"serviceOne"*/'@/components/serviceOne')
const serviceTwo = () => import(/*webpackChunkName:"serviceTwo"*/'@/components/serviceTwo')
const serviceThree = () => import(/*webpackChunkName:"serviceThree"*/'@/components/serviceThree')
const serviceFour = () => import(/*webpackChunkName:"serviceFour"*/'@/components/serviceFour')
const cantact = () => import(/*webpackChunkName:"cantact"*/'@/components/cantact')
const cantactMap = () => import(/*webpackChunkName:"cantact"*/'@/components/cantactMap')
const cases = () => import(/*webpackChunkName:"cases"*/'@/components/cases')
const casesList = () => import(/*webpackChunkName:"cases"*/'@/components/casesList')
const casesDetail = () => import(/*webpackChunkName:"cases"*/'@/components/casesDetail')
const cantactRecruitment = () => import(/*webpackChunkName:"cantactRecruitment"*/'@/components/cantactRecruitment')
const about = () => import(/*webpackChunkName:"about"*/'@/components/about')
const wluotxMap = () => import(/*webpackChunkName:"about"*/'@/components/wluotxMap')
Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			redirect: "/home"	/*路由重定向*/
		},
		{
			path: '/service',
			redirect: "/service/serviceList"	/*路由重定向*/
		},
		{
			path: '/cantact',
			redirect: "/cantact/cantactMap"	/*路由重定向*/
		},
		{
			path: '/cases',
			redirect: "/cases/casesList"	/*路由重定向*/
		},
		{
			path: '/cases/casesDetail',
			redirect: "/cases/casesList"	/*路由重定向*/
		},
		{
			path:'/home',
			name: 'home',		/*路由名称*/
			component: home		/*渲染组件结构（），对应引入的组件*/
		},
		{
			path:'/service',
			name: 'service',
			component: service,
			children:[			/*子路由*/
				{
					path: "/service/serviceList",
					name:'serviceList',
					component: serviceList,
					meta: { isService: true }
				},
				{
					path: "/service/serviceOne",
					name:'serviceOne',
					component: serviceOne,
					meta: { isService: true }
				},
				{
					path: "/service/serviceTwo",
					name:'serviceTwo',
					component: serviceTwo,
					meta: { isService: true }
				},
				{
					path: "/service/serviceThree",
					name:'serviceThree',
					component: serviceThree,
					meta: { isService: true }
				},
				{
					path: "/service/serviceFour",
					name:'serviceFour',
					component: serviceFour,
					meta: { isService: true }
				}

			]
		},
		{
			path:'/about',
			name: 'about',
			component: about
		},
		{
			path: '/cantact',
			name: 'cantact',
			component: cantact,
			children: [			/*子路由*/
				{
					path: "/cantact/cantactMap",
					name: 'cantactMap',
					component: cantactMap,
					meta: { isCantact: true, isCantactMap: true, keepAlive: true}
				},
				{
					path: "/cantact/cantactRecruitment/:id",
					name: 'cantactRecruitment',
					component: cantactRecruitment,
					meta: { isCantact: true,isCantactRe:true}
				}
			]
		},
		{
			path: '/cases',
			name: 'cases',
			component: cases,
			children: [			/*子路由*/
				{
					path: "/cases/casesList",
					name: 'casesList',
					component: casesList,
					meta: { isCases: true,keepAlive:true}
				},
				{
					path: "/cases/casesDetail/:id",
					name: 'casesDetail',
					component: casesDetail,
					meta: { isCases: true }
				}
			]
		},
		{
			path: '/wluotxMap',
			name: 'wluotxMap',
			component: wluotxMap
		}
	],
	scrollBehavior(to, from, savedPosition){
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
})
/**
 * vue-cli搭建
 * 1.安装node.js
 * 2.全局安装 vue-cli 命令：npm install -g vue-cli
 * 3.初始化vue-cli项目，在项目目录 命令：vue init webpack vuedemo
 * 4.vuedemo为项目名称，命令：cd vuedemo
 */
/**
 * npm run dev 项目启动命令
 * npm run build 项目打包命令
 * npm run unit 单元测试
 * npm run lint 运行eslint并报告代码中的linting错误
 * npm run e2e Run end-to-end tests with Nightwatch.
 */
/**
 * 路由参数传递
 * 1.组件vue配置
 *  <router-link :to="{name:'page1',params:{id:text}}">跳往子页面携带id参数</router-link>
 *  page1为路由名称
 *  text为参数，写在data里
 *  export default {
		name:'hello',
		data(){
			return {
				text:'参数'
			}
		}
    },
    methods:{
		
	},
	mounted(){
		//这里可以执行获取参数方法console.log(this.$route.params.id);
	}
 *  参数获取
 * 2.路由js配置
 *  需要传递参数的路由地址后加:id，如：
 *  {
		path:'/page1/:id',
		name:'page1',
		component:page1
 	}
 */
/*By Wendy*/


// WEBPACK FOOTER //
// ./src/router/index.js